import { InputComponentMetadata ,MultilineProperties} from "@eavfw/quickform-core"; 

export const multilineInputSchema: InputComponentMetadata<MultilineProperties> = {
    label: "Multiline Text",
    uiSchema: {
        paragraph: {
            "ui:widget": "textarea"
        }
    },
    schema: {
        type: "object",
        properties: {
            text: {
                title: "Text",
                type: "string"
            },
            placeholder: {
                title: "Placeholder",
                type: "string"
            },
            paragraph: {
                title: "Paragraph",
                type: "string"
            }
        }
    },
    field: {
        type: "text",
    }
}